import { useNavigation } from 'react-day-picker';
import { useTranslation } from 'react-i18next';
import { CaretDown, CaretUp } from '@phosphor-icons/react';

import ButtonIcon from '@tmh-website/ui/ButtonIcon';

import { CalendarThemeColor, calendarThemes } from './Calendar.theme';
import * as Styled from './CalendarNavigation.styles';

interface CalendarNavigationProps {
  themeColor: CalendarThemeColor;
}

const CalendarNavigation = ({ themeColor }: CalendarNavigationProps) => {
  const { goToMonth, previousMonth, nextMonth } = useNavigation();
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <ButtonIcon
        aria-label={t('global:calendar.previousMonth') as string}
        themeColor={calendarThemes[themeColor].captionButtonsThemeColor}
        isSmall
        phosphorPadding
        onClick={() => {
          if (previousMonth) {
            goToMonth(previousMonth);
          }
        }}>
        <CaretUp weight='bold' />
      </ButtonIcon>
      <ButtonIcon
        aria-label={t('global:calendar.nextMonth') as string}
        themeColor={calendarThemes[themeColor].captionButtonsThemeColor}
        isSmall
        phosphorPadding
        onClick={() => {
          if (nextMonth) {
            goToMonth(nextMonth);
          }
        }}>
        <CaretDown weight='bold' />
      </ButtonIcon>
    </Styled.Container>
  );
};

export default CalendarNavigation;
